import { LOGOUT, GET_PAYMENTS } from "../actions/action.types";

const initialState = {
  transactions: [],
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENTS:
      return {
        ...state,
        transactions: action.payload,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default paymentReducer;
